import React, { useState } from 'react';
import styled from 'styled-components';
import { FaHome, FaSearch, FaShoppingCart, FaHeart, FaUserAlt } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';
import { FcGoogle } from 'react-icons/fc';

// Country data for demonstration purposes
const countries = [
  { code: '+91', flag: '🇮🇳', name: 'India' },
  { code: '+1', flag: '🇺🇸', name: 'United States' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+61', flag: '🇦🇺', name: 'Australia' },
  { code: '+81', flag: '🇯🇵', name: 'Japan' },
  // Add more countries as needed
];

const FooterContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  border-top: 1px solid #e0e0e0;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.4rem;
  color: ${({ isSelected }) => (isSelected ? '#66bb6a' : '#333')};
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #66bb6a;
  }
`;

const IconText = styled.span`
  font-size: 0.7rem;
  color: #333;
  margin-top: 0.2rem;
`;

const FullScreenDrawer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  z-index: 1000;
  overflow-y: auto;
`;

const CloseButton = styled.div`
  align-self: flex-end;
  cursor: pointer;
  font-size: 1.5rem;
  color: #666;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-top: 1rem;
`;

const DividerStyled = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  margin: 2rem 0;
`;

const InputWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin-top: 1rem;
  text-align: left;
  position: relative;
`;

const Label = styled.label`
  font-size: 0.9rem;
  color: #666;
  display: block;
  margin-bottom: 0.5rem;
`;

const CountryCodeSelector = styled.div`
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0.5rem;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  user-select: none;
`;

const CountryDropdown = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
`;

const CountryOption = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const Flag = styled.span`
  margin-right: 0.5rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 0 8px 8px 0;
  font-size: 1rem;
  outline: none;
`;

const SendOtpButton = styled.button`
  width: 100%;
  padding: 0.8rem;
  font-size: 1rem;
  color: white;
  background-color: ${({ disabled }) => (disabled ? '#e0e0e0' : '#66bb6a')};
  border: none;
  border-radius: 8px;
  margin-top: 1rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

const IconOptions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const Footer = ({clickSearchIcon}) => {
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [country, setCountry] = useState(countries[0]); // Default country is India
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);

  const handleIconClick = (iconName) => {
    if (iconName === 'login') {
      setDrawerOpen(true);
    }
    if(iconName == 'search')  clickSearchIcon();
    setSelectedIcon(iconName);
  };

  const handleCountrySelect = (country) => {
    setCountry(country);
    setShowCountryDropdown(false);
  };

  return (
    <>
      <FooterContainer>
        <IconWrapper isSelected={selectedIcon === 'home'} onClick={() => handleIconClick('home')}>
          <FaHome />
          <IconText>Home</IconText>
        </IconWrapper>
        <IconWrapper isSelected={selectedIcon === 'search'} onClick={() => handleIconClick('search')}>
          <FaSearch />
          <IconText>Search</IconText>
        </IconWrapper>
        <IconWrapper isSelected={selectedIcon === 'cart'} onClick={() => handleIconClick('cart')}>
          <FaShoppingCart />
          <IconText>Cart</IconText>
        </IconWrapper>
        <IconWrapper isSelected={selectedIcon === 'favorites'} onClick={() => handleIconClick('favorites')}>
          <FaHeart />
          <IconText>Favorites</IconText>
        </IconWrapper>
        <IconWrapper isSelected={selectedIcon === 'login'} onClick={() => handleIconClick('login')}>
          <FaUserAlt />
          <IconText>Login</IconText>
        </IconWrapper>
      </FooterContainer>

      <FullScreenDrawer isOpen={isDrawerOpen}>
        <CloseButton onClick={() => setDrawerOpen(false)}>×</CloseButton>
        <Title>Login / SignUp</Title>
        <DividerStyled />
        <InputWrapper>
          <Label>Enter Mobile No *</Label>
          <div style={{ display: 'flex' }}>
            <CountryCodeSelector onClick={() => setShowCountryDropdown(!showCountryDropdown)}>
              <Flag>{country.flag}</Flag>
              <span>{country.code}</span>
            </CountryCodeSelector>
            <Input
              type="text"
              placeholder="Enter your mobile number"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              maxLength={10}
            />
          </div>
          {showCountryDropdown && (
            <CountryDropdown>
              {countries.map((country, index) => (
                <CountryOption key={index} onClick={() => handleCountrySelect(country)}>
                  <Flag>{country.flag}</Flag>
                  <span>{country.name} ({country.code})</span>
                </CountryOption>
              ))}
            </CountryDropdown>
          )}
        </InputWrapper>
        <SendOtpButton
          disabled={mobileNumber.length !== 10}
          onClick={() => alert('OTP Sent')}
        >
          Send OTP
        </SendOtpButton>
        <DividerStyled></DividerStyled>
        <span>or</span>
        <IconOptions>
          <IoMdMail size={28} color="#666" />
          <FcGoogle size={28} />
        </IconOptions>
      </FullScreenDrawer>
    </>
  );
};

export default Footer;
